import React from "react";
import { Tag, Popover } from "antd";
import ShipmentTagsLib from "../../../../../lib/fulfillment/shipmentTags";
import { QuestionCircleOutlined } from "@ant-design/icons";
import * as S from "./styles";

const ShipmentTagTitle = () => {
  const tags = ShipmentTagsLib.getShipmentTagsDescriptions();
  const rows = tags.map((t) => {
    const tag = t.tag;
    const text = ShipmentTagsLib.getShipmentTagText(tag);
    const color = ShipmentTagsLib.getShipmentTagColor(tag);
    return (
      <div key={tag} className="tag-description-row">
        <Tag color={color}>{text}</Tag>
        <S.ShipmentTagDescription className="description">- {t.description}</S.ShipmentTagDescription>
      </div>
    );
  });

  const content = <div className="tag-description-box">{rows}</div>;

  return (
    <div className="shipment-tags-title">
      <div>
        Shipment Tags{" "}
        <Popover content={content}>
          <QuestionCircleOutlined className="shipment-tag-description-trigger" />
        </Popover>
      </div>
    </div>
  );
};

export default ShipmentTagTitle;
